// @flow
import FormikDateField from 'components/formik/FormikDateField'
import FormikPhoneField from 'components/formik/FormikPhoneField'
import FormikSelectField from 'components/formik/FormikSelectField'
import FormikTextField from 'components/formik/FormikTextField'
import * as React from 'react'

type Props = {
  isEditMode: boolean,
}

function ClientDemographicsTableDemographics({
  isEditMode,
}: Props): React.Node {
  return (
    <div className="grid grid-cols-12 gap-x-6 gap-y-4 pt-1">
      <div className="col-span-12 md:col-span-4">
        <FormikTextField
          disabled={!isEditMode}
          label="First name"
          name="first_name"
          placeholder="First name"
        />
      </div>
      <div className="col-span-12 md:col-span-4">
        <FormikTextField
          disabled={!isEditMode}
          label="Middle name"
          name="middle_name"
          placeholder="Middle name"
        />
      </div>
      <div className="col-span-12 md:col-span-4">
        <FormikTextField
          disabled={!isEditMode}
          label="Last name"
          name="last_name"
          placeholder="Last name"
        />
      </div>
      <div className="col-span-12 md:col-span-4">
        <FormikDateField
          disabledGrayed
          semibold
          disabled={!isEditMode}
          label="Date of Birth"
          name="date_birth"
        />
      </div>
      <div className="col-span-12 md:col-span-4">
        <FormikTextField
          disabled={!isEditMode}
          label="Email"
          name="email"
          placeholder="Email"
          type="email"
        />
      </div>
      <div className="col-span-12 md:col-span-4">
        <FormikSelectField
          semibold
          disabled={!isEditMode}
          label="Preferred Contact Method"
          name="preferred_contact"
          options={[
            { label: '-- Select --', value: '' },
            { label: 'Email', value: 'Email' },
            { label: 'SMS', value: 'SMS' },
            { label: 'Phone', value: 'Phone' },
            { label: 'Passport', value: 'Passport' },
          ]}
        />
      </div>
      <div className="col-span-12 md:col-span-4">
        <FormikTextField
          disabled={!isEditMode}
          label="Gender"
          name="sex_at_birth"
          placeholder="Gender"
        />
      </div>
      <div className="col-span-12 md:col-span-4">
        <FormikPhoneField
          disabled={!isEditMode}
          label="Mobile Phone"
          name="phone_number"
          placeholder="Mobile Phone number"
        />
      </div>
      <div className="col-span-12 md:col-span-4">
        <FormikPhoneField
          disabled={!isEditMode}
          label="Home Phone"
          name="home_phone_number"
          placeholder="Home Phone number"
        />
      </div>
      <div className="col-span-12 md:col-span-4">
        <FormikPhoneField
          disabled={!isEditMode}
          label="Work Phone"
          name="work_phone_number"
          placeholder="Work Phone number"
        />
      </div>
      <div className="col-span-6 md:col-span-6">
        <FormikTextField
          disabled={!isEditMode}
          label="Address"
          name="address"
          placeholder="Address"
        />
      </div>
      <div className="col-span-6 md:col-span-6">
        <FormikTextField
          disabled={!isEditMode}
          label="Apt or Ste #"
          name="address2"
          placeholder="Apt or Ste #"
        />
      </div>
      <div className="col-span-6 md:col-span-4">
        <FormikTextField
          disabled={!isEditMode}
          label="City"
          name="city"
          placeholder="City"
        />
      </div>
      <div className="col-span-6 md:col-span-4">
        <FormikTextField
          disabled={!isEditMode}
          label="State"
          name="state"
          placeholder="State"
        />
      </div>
      <div className="col-span-6 md:col-span-4">
        <FormikTextField
          disabled={!isEditMode}
          label="Zip"
          name="zipcode"
          placeholder="Zip"
        />
      </div>
      <div className="col-span-12 md:col-span-4">
        <FormikTextField
          disabled={!isEditMode}
          label="Provider"
          name="provider"
          placeholder="Provider"
        />
      </div>
    </div>
  )
}

export default ClientDemographicsTableDemographics
